var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.089,
    height: 28.53,
    viewBox: "0 0 25.089 28.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-180.694 -757.485)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(180.694 757.485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.2,223.671v-8.038a1.028,1.028,0,0,1,1.085-1.1q6.327-.007,12.65,0a1.039,1.039,0,0,1,1.094,1.1v16.144a1.026,1.026,0,0,1-1.046,1.094c-.058,0-.12,0-.178,0H253.429a1.136,1.136,0,0,1-.859-.24,1.092,1.092,0,0,1-.37-.83Q252.207,227.74,252.2,223.671Zm3.182.043V229.4c0,.307,0,.307.312.307h7.837c.312,0,.312,0,.312-.307V218.022c0-.307,0-.312-.3-.312h-7.861c-.3,0-.3,0-.3.312Z",
    transform: "translate(-241.949 -204.369)",
    fill: "#fd6c50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.758,20.963c0,3.167-.01,6.33.01,9.5a.9.9,0,0,1-.969.969c-.552-.01-1.1.01-1.656-.038a.784.784,0,0,1-.705-.816V11.4c0-.35,0-.35-.35-.35H39.569a.858.858,0,0,1-.969-.984V8.616a.826.826,0,0,1,.883-.883c1.224,0,2.447,0,3.671,0,.23,0,.288-.072.288-.293-.01-1.2,0-2.4,0-3.6a.836.836,0,0,1,.936-.941h1.478a.809.809,0,0,1,.907.917V7.353c0,.384,0,.384.374.384q7.825,0,15.654,0a.8.8,0,0,1,.773.394,1.012,1.012,0,0,1,.12.442c.014.542.01,1.089,0,1.636a.825.825,0,0,1-.825.849c-.082,0-.163,0-.245,0h-15.5c-.36,0-.36,0-.36.35Q46.761,16.176,46.758,20.963Z",
    transform: "translate(-38.6 -2.9)",
    fill: "#fd6c50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogo);
export default __webpack_public_path__ + "static/media/sidebar_logo.3fc4018e2e4a9d9a488d239b811f74f1.svg";
export { ForwardRef as ReactComponent };